module.exports = __webpack_public_path__ + "img/ios7-clock-outline.2ef42990.png";